import React, { useState } from "react";
import moment from "moment/moment";
import { Badge } from "primereact/badge";

import { SecondaryButton } from "../../../../Components/Button";
import AssignOrderModal from "./AssignOrderModal";

const DispatchOrderCard = ({ item, allDeliveryMan,fetchAllDeliveryMan }) => {
  // console.log("item order:",item);
  const [isAssignModal,setIsAssignModal]=useState(false);
  const [isAssignItem,setIsAssignItem]=useState('');
  return (
    <div className="border-b p-2 rounded-md">
      <div className="flex justify-between">
        <div>
          <p>{item.delivery_address.name}</p>
          <p>{item.delivery_address.phone_number}</p>
        </div>
        <div className="text-end">
          <p> {item.order_id}</p>
          <p>{moment(item.order_date).format("MMM Do, YYYY")}</p>
        </div>
      </div>
      <p>
        {item.delivery_address.street},{item.delivery_address.city.name},
        {item.delivery_address.country.name}
      </p>
      <div className="flex justify-between items-center">
      <Badge
          className="text-[10px] px-2"
          severity={"info"}
          value={item.orderDetails[0].vendor_action
            ==="ASSIGN"?"Assigning":""}
        />
        {/* <SecondaryButton
        padding='px-2 py-1'
        borderColor='border-blue-500'
          onClick={() => {
            setIsAssignModal(true);
            setIsAssignItem(item);
          }}
          text="Assign for Delivery"
        /> */}
      <button 
      className="px-2 py-1 border border-blue-500 text-blue-600 rounded-xl hover:bg-blue-100" 
      onClick={() => {
        setIsAssignModal(true);
        fetchAllDeliveryMan();
        setIsAssignItem(item);
      }}
      >Assign for Delivery
      </button>
         
      </div>
      {isAssignModal && (
        <AssignOrderModal allDeliveryMan={allDeliveryMan} isAssignModal={isAssignModal} itemData={item} setIsAssignModal={setIsAssignModal}/>
      )}
    </div>
  );
};

export default DispatchOrderCard;
